import { FC } from 'react';
import { faStar } from '@fortawesome/free-solid-svg-icons';

import { IconButton } from '../../../component/IconButton';
import { IndexNumber } from '../../../component/IndexNumber';
import {
  formatNumber,
  priceFormatter
} from '../../../model/utils/helper/formatter';
import classNames from 'classnames';
import BigNumber from 'bignumber.js';
import { zero } from '../../../model/utils/helper';
import * as styles from './index.module.less';

export interface AssetIndexProps {
  className?: string;
  baseTokenSymbol: string;
  baseTokenName: string;
  quoteTokenSymbol: string;
  fiatPrice: BigNumber;
  fiatCurrency: string;
  lastPrice: BigNumber;
  open: BigNumber;
  high: BigNumber;
  low: BigNumber;
  close: BigNumber;
  volume: BigNumber;
}

const bnSafe = (bn?: BigNumber): BigNumber => {
  return !bn || bn.isNaN() ? zero : bn;
};
export const AssetIndex: FC<AssetIndexProps> = props => {
  const {
    className,
    baseTokenSymbol = '',
    baseTokenName = '',
    quoteTokenSymbol = '',
    fiatPrice = zero,
    fiatCurrency = 'USD'
  } = props;
  const lastPrice = bnSafe(props?.lastPrice);
  const open = bnSafe(props?.open);
  const high = bnSafe(props?.high);
  const low = bnSafe(props?.low);
  const close = bnSafe(props?.close);
  const volume = bnSafe(props?.volume);
  const changed = open.eq(zero)
    ? zero
    : close.minus(open).div(open).multipliedBy(100);
  return (
    <ul className={styles['asset-index-wrap']}>
      <li>
        <h2 className={classNames('m-0', 'text-white', styles.symbol)}>
          {baseTokenSymbol}/{quoteTokenSymbol}
          <IconButton color="secondary" icon={faStar} className={styles.btn} />
        </h2>
        <small>{baseTokenName}</small>
      </li>
      <li>
        <IndexNumber value={formatNumber(lastPrice.toNumber())} />
      </li>
      <li>
        Fiat Price
        <div className="text-white">
          {priceFormatter.format(fiatPrice.toNumber())} {fiatCurrency}
        </div>
      </li>
      <li>
        Change
        <div className="text-success">
          <IndexNumber showIcon value={close.minus(open).toNumber()} /> (
          <IndexNumber value={`${changed.toFixed(2)}%`} />)
        </div>
      </li>
      <li>
        24H High
        <div className="text-white">
          {priceFormatter.format(high.toNumber())}
        </div>
      </li>
      <li>
        24H Low
        <div className="text-white">
          {priceFormatter.format(low.toNumber())}
        </div>
      </li>
      <li>
        24H Vol
        <div className="text-white">
          {formatNumber(volume.toNumber())} {baseTokenSymbol}
        </div>
      </li>
    </ul>
  );
};
